import React, { useCallback, useEffect, useState } from 'react';
import './SessionDetails.css';
import { Box } from '@mui/material';
import Layout from '../../../components/Layout';
import TeacherNavbar from '../../../components/TeacherNavbar/TeacherNavbar';
import { useParams } from 'react-router-dom';
import { axiosInstance } from '../../../utils/tokenUtils';
import OneOnOneSessionDetails from '../../../components/SessionDetails/OneOnOneSessionDetails/OneOnOneSessionDetails';
import GroupSessionDetails from '../../../components/SessionDetails/GroupSessionDetails/GroupSessionDetails';
import PrimeSessionDetails from '../../../components/SessionDetails/PrimeSessionDetails/PrimeSessionDetails';

const SessionDetails = () => {
  const [singleSessionDetails, setSingleSessionDetails] = useState([]);
  const { sessionId } = useParams();

  const getSessionDetailsData = useCallback(async () => {
    try {
      const { data } = await axiosInstance.get(`/teachers/sessions/${sessionId}`);
      setSingleSessionDetails(data);
    } catch (error) {
      console.log(error);
    }
  }, [sessionId]);

  useEffect(() => {
    getSessionDetailsData();
  }, [getSessionDetailsData]);

  return (
    <Layout title="Klass Online | Schedule">
      <Box className="relative h-screen w-full overflow-hidden">
        <Box className="sticky top-0 left-0 right-0 z-[1000] bg-white pr-[10px]">
          <TeacherNavbar />
          <Box className="h-[calc(100vh-64px)] overflow-auto relative bg-[#F9F9F9] rounded-lg mr-[10px]">
            <Box className="flex flex-col p-[1rem] gap-3">
              {singleSessionDetails?.session_type === 'one_on_one' ? (
                <OneOnOneSessionDetails singleSessionDetails={singleSessionDetails} />
              ) : singleSessionDetails?.session_type === 'group' ? (
                <GroupSessionDetails singleSessionDetails={singleSessionDetails} />
              ) : (
                <PrimeSessionDetails singleSessionDetails={singleSessionDetails} />
              )}
            </Box>
          </Box>
        </Box>
      </Box>
    </Layout>
  );
};

export default SessionDetails;
